import type { Cart, Product } from './types'

/** "5.00 RON", the way plan prices are written everywhere else in the gym app. */
export function formatMoney(amount: number, currency: string): string {
  return `${amount.toFixed(2)} ${currency}`
}

export function cartCount(cart: Cart): number {
  return cart.items.reduce((sum, line) => sum + line.quantity, 0)
}

/**
 * A cart holds no prices. It is priced from the catalogue as it stands now,
 * which is exactly how the sale will price it. A line whose product is no
 * longer in the catalogue counts for nothing here.
 */
export function cartTotal(cart: Cart, products: Map<string, Product>): number {
  return cart.items.reduce(
    (sum, line) => sum + line.quantity * (products.get(line.product_id)?.sell_price ?? 0),
    0,
  )
}

/** Who a cart is for: the member's name, or the walk-in's label. */
export function cartName(cart: Cart): string {
  if (!cart.member) return cart.label ?? ''
  const full = [cart.member.first_name, cart.member.last_name].filter(Boolean).join(' ')
  return full || cart.member.nickname || cart.member.email || ''
}

/** The small version of a product picture, for tiles and rows. */
export function thumbUrl(imageUrl: string): string {
  return `${imageUrl}${imageUrl.includes('?') ? '&' : '?'}size=thumb`
}
